<template>
  <div>
    <v-row>
      <v-col :cols="12" :sm="6">
        <UICardBody>
          <v-skeleton-loader type="article, list-item-three-line" />
        </UICardBody>
      </v-col>
      <v-col :cols="12" :sm="6">
        <UICardBody class="mb-6 w-full">
          <v-skeleton-loader type="article, list-item-three-line" />
        </UICardBody>
        <UICardBody class="w-full">
          <v-skeleton-loader type="article, list-item-three-line" />
        </UICardBody>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
import UICardBody from '../ui-card-body/UICardBody.vue';
</script>

<style scoped lang="scss"></style>
